/* eslint-disable react/prop-types */
import React from 'react';
import { Form } from 'react-bootstrap5';

import {
  ErrorMessage,
  Field,
  useField,
} from 'formik';

export default function HorizontalRangeField(props) {
  const {
    name, label, placeholder, type, hint, required, className, ...rest
  } = props;

  const [meta] = useField(props);

  const errorClass = meta.error !== undefined && meta.touched ? 'is-invalid' : '';

  return (
    <Form.Group className="mb-3" controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <div className={`d-flex gap-2 ${className} ${errorClass}`}>

        <Field
          autoComplete="off"
          className={`form-range numeric range optional  ${errorClass}`}
          type={type || 'range'}
          name={name}
          placeholder={placeholder || ''}
          {...rest}
        />
      </div>

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}
